export const ParkingDisplayStatuses = {
  SUCCESSFUL_PARKING: 1,
  COULD_NOT_READ_PLATE: 2,
  PLATE_NOT_IN_DB: 3,
  PARKING_FULL: 4,
};
